import { auth0Service } from "./auth0Service";
import { JWT_TOKEN, SILENT_AUTH } from "lib/Constants";
import { hasNullValue, setLocalStorageData } from "lib/utils";

const SILENT_LOGIN_ERROR_CODES = new Set([
	"login_required",
	"consent_required",
	"interaction_required",
	"missing_refresh_token",
]);

export async function silentLogin(): Promise<boolean> {
	try {
		const tokens = (await auth0Service.silentLogin()) as any;
		if (tokens) {
			const token = tokens?.access_token ?? tokens;
			setLocalStorageData(JWT_TOKEN, token);
			return true;
		}
	} catch (err: any) {
		if (SILENT_LOGIN_ERROR_CODES.has(err?.error) && hasNullValue(SILENT_AUTH)) {
			await auth0Service.loginWithRedirectOnly();
		}
		console.log(err, "while silent");
		return false;
	}
	return false;
}

export async function validateUserOnAppLoad(): Promise<{ needsLogin: boolean; user?: any }> {
	try {
		const isAuth = await auth0Service.isAuthenticated();
		if (isAuth) {
			const user = await auth0Service.getUser();
			try {
				await silentLogin();
			} catch (e) {
				console.warn("Could not store token:", e);
			}

			return { needsLogin: false, user };
		}
		const ssoSuccess = await silentLogin();
		if (ssoSuccess) {
			const user = await auth0Service.getUser();
			return { needsLogin: false, user };
		}
		return { needsLogin: true };
	} catch (error) {
		return { needsLogin: true };
	}
}
